import axios from 'axios';
import { RestaurantInterface } from 'restpay-api-lib/lib/@types/_interfaces/restaurants/restaurant.interface';
import { API_LINKS } from '../constants/links';

export const fetchRestaurant = (restaurantId: string): Promise<RestaurantInterface> =>
	axios.get(`${API_LINKS.FETCH_RESTAURANTS}${restaurantId}`);

export const fetchRestaurantComments = (restaurantId: string) =>
	axios.get(`${API_LINKS.FETCH_RESTAURANTS}${restaurantId}/comments`);
